<template>
  <div>
    <a-modal
      v-model="addUserModalVisible"
      title="add permission to role"
      :footer="null"
     
    >
      <a-table
        :columns="columns2"
        :row-key="(record) => record._id"
        :data-source="data2"
        :pagination="pagination2"
        :loading="loading2"
        @change="handleTableChange2"
        bordered
        size="small"
      >
        <template slot="title" slot-scope="">
          <a-input-search
            placeholder="search permission ..."
            enter-button
            size="small"
            @search="onSearch2"
          />
        </template>

        <template slot="name" slot-scope="name, item">
          <a-space>
            <a-button @click="addPermissionToRole(item._id)"
              >add to role</a-button
            >
            <a-tag
              color="blue"
              @click="addPermissionToRole(item._id)"
              style="cursor:pointer;"
            >
              {{ name }}
            </a-tag>
          </a-space>
        </template>
        <template slot="bool" slot-scope="bool">
          <a-icon v-if="bool" type="check-circle" class="text-success" />
          <a-icon v-if="!bool" type="close-circle" class="text-danger" />
        </template>
        <template slot="date" slot-scope="date">
          <a-tag color="orange">
            {{ momentom(date) }}
          </a-tag>
        </template>
      </a-table>
    </a-modal>

    <a-table
      :columns="columns"
      :row-key="(record) => record._id"
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      bordered
      size="small"
    >
      <template slot="title" slot-scope="">
        <a-space>
          <!-- <a-input-search
            placeholder="search users by username,email,phone ..."
            style="width: 500px"
            enter-button
            size="small"
            @search="onSearch"
          /> -->
          <a-button
            @click="toggleAddUserModal"
            type="default"
            class="bg-success"
            shape="round"
            icon="plus"
            size="small"
            >add permission</a-button
          >
          <a-button
            @click="() => fetch()"
            type="dark"
            shape="round"
            icon="reload"
            size="small"
            >reload</a-button
          >

          <transition name="bounce">
            <a-tag color="blue" v-show="showRoleName"
              >permissions of -> (<strong>{{ this.roleName }}</strong
              >)
            </a-tag>
          </transition>
        </a-space>
      </template>

      <template slot="bool" slot-scope="bool">
        <a-icon v-if="bool" type="check-circle" class="text-success" />
        <a-icon v-if="!bool" type="close-circle" class="text-danger" />
      </template>
      <template slot="date" slot-scope="date">
        <a-tag color="orange">
          {{ momentom(date) }}
        </a-tag>
      </template>
      <template slot="actions" slot-scope="item">
        <a-popconfirm
          title="Sure to delete?"
          @confirm="() => removePermissionFromRole(item._id)"
        >
          <a-button
            type="danger"
            size="small"
            shape="circle"
            icon="minus"
            title="remove from role"
          />
        </a-popconfirm>
      </template>
    </a-table>
  </div>
</template>

<script>
import moment from "moment";
import { copyTextToClipboard } from "../../utils/common";

export default {
  props: {
    roleId: {
      type: String,
      default: "",
    },
    roleName: {
      type: String,
      default: "",
    },
  },
  watch: {
    roleId: function() {
      this.showRoleName = false;
      setTimeout(() => {
        this.showRoleName = true;
      }, 1000);
      this.fetch();
    },
  },
  data() {
    return {
      formLayout: "horizontal",
      form: this.$form.createForm(this, { name: "coordinated" }),
      apps: [],
      showRoleName: true,
      newUserModalVisible: false,
      addUserModalVisible: false,
      columns: [
        {
          title: "permission name",
          dataIndex: "permission.name",
          width: "40%",
          scopedSlots: { customRender: "name" },
        },
        {
          title: "description",
          dataIndex: "permission.description",
        },
        {
          title: "",
          scopedSlots: { customRender: "actions" },
        },
      ],
      pagination: {},
      data: [],
      loading: false,
      columns2: [
        {
          title: "permission name",
          dataIndex: "name",
          sorter: true,
          width: "45%",
          scopedSlots: { customRender: "name" },
        },
        {
          title: "description",
          dataIndex: "description",
        },
      ],
      pagination2: {},
      data2: [],
      loading2: false,
    };
  },
  methods: {
    handleTableChange(pagination, filters, sorter) {
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      this.pagination = pager;
      const params = {
        pageSize: pagination.pageSize,
        page: pagination.current,
        ...filters,
      };
      if (sorter.order) {
        params.sort =
          sorter.order === "ascend" ? sorter.field : `-${sorter.field}`;
      }
      this.fetch(params);
    },
    handleTableChange2(pagination, filters, sorter) {
      const pager = { ...this.pagination2 };
      pager.current = pagination.current;
      this.pagination2 = pager;
      const params = {
        pageSize: pagination.pageSize,
        page: pagination.current,
        ...filters,
      };
      if (sorter.order) {
        params.sort =
          sorter.order === "ascend" ? sorter.field : `-${sorter.field}`;
      }
      this.fetch2(params);
    },
    fetch(params = {}) {
      if (!this.roleId) {
        this.loading = false;
        return;
      }
      this.loading = true;
      const p = Object.assign(
        {
          populate: ["permission"],
        },
        params
      );

      Object.assign(p, {
        query: {
          rId: this.roleId,
          accType: 3,
        },
        fields: "_id, permission",
      });

      this.axios.get(`/api/auth`, { params: p }).then(({ data }) => {
        const pagination = { ...this.pagination };
        // Read total count from server
        pagination.total = data.total;
        this.loading = false;
        this.data = data.rows;
        this.pagination = pagination;
      });
    },
    fetch2(params = {}) {
      this.loading2 = true;
      const p = Object.assign(
        {
          fields: "_id, name, description",
          query: {
            active: true,
          },
        },
        params
      );
      this.axios.get(`/api/permissions`, { params: p }).then(({ data }) => {
        const pagination = { ...this.pagination2 };
        // Read total count from server
        pagination.total = data.total;
        this.loading2 = false;
        this.data2 = data.rows;
        this.pagination2 = pagination;
      });
    },
    momentom(input) {
      let date = moment(input);
      return date.fromNow();
    },
    copy(text) {
      copyTextToClipboard(text);
      this.$message.info("copied !");
    },
    onSearch(t, e) {
      if (t) {
        this.fetch({
          searchFields: ["username", "email", "phone", "firstName", "lastName"],
          search: t,
        });
      } else {
        this.fetch({});
      }
    },
    onSearch2(t, e) {
      if (t) {
        this.fetch2({
          searchFields: ["name", "description"],
          search: t,
        });
      } else {
        this.fetch2({});
      }
    },
    toggleUserModal() {
      this.newUserModalVisible = !this.newUserModalVisible;
    },
    toggleAddUserModal() {
      if (this.roleId === "" || !this.roleId) {
        this.$message.error("first select a role!! and try to add user");
        return;
      }
      this.addUserModalVisible = !this.addUserModalVisible;
    },
    handleCreateUser() {
      this.form.validateFields((err, values) => {
        if (!err) {
          this.axios
            .post("/api/users", values)
            .then(({ data }) => {
              this.$message.info("user created successfully !");
              this.fetch();
              this.toggleUserModal();
              this.form = this.$form.createForm(this, { name: "coordinated" });
            })
            .catch((err) => {});
          console.log("Received values of form: ", values);
        }
      });
    },
    loadApps() {
      this.axios
        .get("/public/auth/apps")
        .then(({ data }) => {
          this.apps = data.rows;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    handleSelectChange(value) {},
    handleSelectChange2(value) {},
    addPermissionToRole(permissionId) {
      if (this.roleId === "" || !this.roleId) {
        this.$message.error("first select a role!! and try to add permission");
        return;
      }
      this.axios
        .post("/api/auth", {
          rId: this.roleId,
          pId: permissionId,
          //RolePerm
          accType: 3,
        })
        .then(({ data }) => {
          this.$message.success(`opration success`);
          this.fetch();
        });
    },
    removePermissionFromRole(accessId) {
      this.axios.delete(`/api/auth/force/${accessId}`).then(({ data }) => {
        this.$message.success(`opration success`);
        this.fetch();
      });
    },
  },
  mounted() {
    this.fetch2();
  },
};
</script>

<style lang="css">
.bounce-enter-active {
  animation: bounce-in 0.5s;
}
.bounce-leave-active {
  animation: bounce-in 0.5s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}
</style>
